const design = [
    {
      desc: "Sumaketuota knyga",
      pic:
        "/pic/kn.jpg",
    },
    {
      desc: "Sumaketuota knyga",
      pic:
        "/pic/pa.jpg",
    },
    {
      desc: "Reklama",
      pic:
        "/pic/is.jpg",
    },
    {
      desc: "Sumaketuota knyga",
      pic:
        "/pic/book.jpg",
    },
    {
      desc: "3D vizualizacija",
      pic:
        "/pic/11.jpg",
    },
    {
      desc: "Reklama",
      pic:
        "/pic/u.jpg",
    },
    {
      desc: "Sumaketuota knyga",
      pic:
        "/pic/dai.jpg",
    },
    {
      desc: "Logotipas",
      pic:
        "/pic/22.png",
    },
    {
      desc: "Sumaketuota knyga",
      pic:
        "/pic/gyv.jpg",
    },
    {
      desc: "Sumaketuota knyga",
      pic:
        "/pic/ba.jpg",
    },
    {
      desc: "Sumaketuota knyga",
      pic:
        "/pic/ge.jpg",
    },
    {
      desc: "Reklama",
      pic:
        "/pic/t.jpg",
    },
  ];
  export default design